import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const AcountingHeading = (props) => {
  const { reportName } = props
  return (
    <Box sx={{ paddingLeft: '24px', paddingRight: '24px' }} className="reports-heading">
      <Typography variant="h5" className="reports-heading-h5 flex">
        <Typography variant='span'>Cargo System</Typography>
        <KeyboardDoubleArrowRightIcon/>
        <Typography variant='span'>Acounting Reports</Typography>
        <KeyboardDoubleArrowRightIcon/>
        <Typography variant='span'>{`${reportName?reportName:''} Report`}</Typography>     
      </Typography>
    </Box>
  )
}
